import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { QuoteProvider } from "./contexts/QuoteContext";
import { SiteLayout } from "./components/SiteLayout";
import { Home } from "./pages/Home";
import { ComingSoon } from "./pages/ComingSoon";
export function App() {
  return <QuoteProvider data-id="element-0" data-mp="3f9ydv66c1wtv">
      <BrowserRouter data-id="element-1" data-mp="3fbt2ovkq6938">
        <Routes data-id="element-2" data-mp="3fb9i173ox6li">
          <Route element={<SiteLayout data-id="element-4" data-mp="2rkno0jqitmui" />} data-id="element-3" data-mp="3f8nerjnu1d93">
            <Route path="/" element={<Home data-id="element-6" data-mp="2rlf6qtz0rq3d" />} data-id="element-5" data-mp="2rk426rxr2eb7" />
            <Route path="*" element={<ComingSoon data-id="element-8" data-mp="2mm2o6lf6l56l" />} data-id="element-7" data-mp="2risy0r0e74jk" />
          </Route>
        </Routes>
      </BrowserRouter>
    </QuoteProvider>;
}